import { FactoryInstance } from '../../../factory';
import { Collapsible } from './Collapsible';
export * from './Collapsible';
FactoryInstance.registerComponent(Collapsible);
